import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons";
import heroImg from "../components/images/ranchWeddingImages/lakeside1.jpg";
import beefCakesLogo from "../components/images/vendors/beefCakes.jpg";
import beefCakesCake from "../components/images/vendors/beefCakesCake.jpg";
import whiteWaterLogo from "../components/images/vendors/wwBakeryLogo.png";
import whiteWaterPic from "../components/images/vendors/WWBakePic.jpeg";
import shuggaCookieLogo from "../components/images/vendors/shuggaCookieLogo.jpg";
import shuggaCookiePic from "../components/images/vendors/shuggaCookiePic.jpg";
import santeLogo from "../components/images/vendors/SANTE-LOGO.png";
import santePhotography from "../components/images/vendors/SANT8790-1-768x512.jpg";
import imgByDaniLogo from "../components/images/vendors/imgByDani.jpg";
import imgByDaniPic from "../components/images/vendors/imgByDaniPic.jpg";
import lostTreesLogo from "../components/images/vendors/lostInTheTreesLogo.png";
import lostTreesPic from "../components/images/vendors/lostTreesPic.jpg";
import thirstyWheelLogo from "../components/images/vendors/theThirstyWheelLogo.jpg";
import thirstyWheelPic from "../components/images/vendors/theThirstyWheelSetup.jpg";
import alphaLitLogo from "../components/images/vendors/alphaLitLogo.jpg";
import alphaLitPic from "../components/images/vendors/alphaLitPic.jpg";
import boujeePixLogo from "../components/images/vendors/boujeePixLogo.jpg";
import boujeePixPic from "../components/images/vendors/boujeePixPic.jpg";
import "../assets/css/vendors.css";

const categories = [
  {
    title: "Bakeries",
    vendors: [
      {
        name: "Beef Cakes",
        logo: beefCakesLogo,
        photo: beefCakesCake,
        website: "https://www.beefcakesgp.com",
        facebook: "https://www.facebook.com/beefcakesgp",
        instagram: "https://www.instagram.com/beef_cakes_gp/",
      },
      {
        name: "Whitewater Bakery",
        logo: whiteWaterLogo,
        photo: whiteWaterPic,
        website: "https://whitewater-bakery.com/",
        facebook: "https://www.facebook.com/profile.php?id=100045587697076&mibextid=ZbWKwL",
        instagram: "https://www.instagram.com/whitewater_bakery/?igshid=YTQwZjQ0NmI0OA%3D%3D",
      },
      {
        name: "Shugga Cookie",
        logo: shuggaCookieLogo,
        photo: shuggaCookiePic,
        website: "https://www.shuggacookie.com/",
        facebook: "https://www.facebook.com/shuggacookiegp?mibextid=ZbWKwL",
        instagram: "https://www.instagram.com/shuggacookiegp/",
      },
    ],
  },
  {
    title: "Photographers",
    vendors: [
      {
        name: "Sante Photography",
        logo: santeLogo,
        photo: santePhotography,
        website: "https://santephotography.com/",
        facebook: "https://www.facebook.com/santeimages",
        instagram: null,
      },
      {
        name: "Images By Danielle",
        logo: imgByDaniLogo,
        photo: imgByDaniPic,
        website: "https://danielleunger.com/",
        facebook: "https://www.facebook.com/imagesbydanielle?mibextid=ZbWKwL",
        instagram: "https://www.instagram.com/imagesbydanielle/",
      },
      {
        name: "Lost in the Trees Media",
        logo: lostTreesLogo,
        photo: lostTreesPic,
        website: "https://www.lostinthetreesmedia.com/",
        facebook: "https://www.facebook.com/LostintheTreesMedia?mibextid=ZbWKwL",
        instagram: "https://www.instagram.com/lost_in_the_trees_media/",
      },
    ],
  },
  {
    title: "Additional Services",
    vendors: [
      {
        name: "The Thirsty Wheel",
        logo: thirstyWheelLogo,
        photo: thirstyWheelPic,
        website: "https://www.thethirstywheel.com",
        facebook: "https://www.facebook.com/thethirstywheel/",
        instagram: "https://www.instagram.com/the_thirsty_wheel/",
      },
      {
        name: "Alpha-Lit Medford",
        logo: alphaLitLogo,
        photo: alphaLitPic,
        website: "https://www.alphalitletters.com/",
        facebook: "https://www.facebook.com/alphalitmedford?mibextid=ZbWKwL",
        instagram: "https://www.instagram.com/alphalitdallas/",
      },
      {
        name: "Boujee Pix Photo Booth Co.",
        logo: boujeePixLogo,
        photo: boujeePixPic,
        website: "https://www.southernoregonlitevents.com/",
        facebook: "https://www.facebook.com/boujeepix",
        instagram: "https://www.instagram.com/boujeepix_photobooth/",
      },
    ],
  },
];

export default function Vendors() {
  return (
    <>
      <div className="vendors-hero">
        <img className="vendors-hero-img" src={heroImg} alt="Cascade Mountain Ranch lakeside" />
        <div className="vendors-hero-overlay">
          <p className="vendors-hero-eyebrow">Cascade Mountain Ranch</p>
          <h1>Vendors</h1>
          <p className="vendors-hero-sub">Our Preferred Partners</p>
        </div>
      </div>

      <div className="vendors-section">
        <Container>

          <div className="vendors-intro">
            <div className="vendor-accent-line"></div>
            <p>
              We believe that every wedding is a unique celebration, and we want to ensure that your
              special day is everything you've dreamed of. While you have the freedom to bring your
              own vendors, we've curated a list of exceptional partners who have a proven track record
              of delivering unforgettable experiences — carefully selected for their expertise,
              creativity, and commitment to making your day extraordinary.
            </p>
          </div>

          {categories.map((category) => (
            <div className="vendor-category" key={category.title}>
              <h2 className="vendor-category-title">{category.title}</h2>
              <div className="vendor-category-line"></div>
              <Row>
                {category.vendors.map((vendor) => (
                  <Col xl={4} md={6} key={vendor.name}>
                    <div className="vendor-card">
                      <div className="vendor-card-logo">
                        <img src={vendor.logo} alt={`${vendor.name} logo`} />
                      </div>
                      <h3 className="vendor-card-name">{vendor.name}</h3>
                      <a
                        className="vendor-card-btn"
                        href={vendor.website}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Visit Website
                      </a>
                      <div className="vendor-card-socials">
                        {vendor.facebook && (
                          <a href={vendor.facebook} target="_blank" rel="noreferrer" aria-label="Facebook">
                            <FontAwesomeIcon icon={faFacebook} />
                          </a>
                        )}
                        {vendor.instagram && (
                          <a href={vendor.instagram} target="_blank" rel="noreferrer" aria-label="Instagram">
                            <FontAwesomeIcon icon={faInstagram} />
                          </a>
                        )}
                      </div>
                      <div className="vendor-card-photo">
                        <img src={vendor.photo} alt={vendor.name} loading="lazy" />
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          ))}

        </Container>
      </div>
    </>
  );
}
